// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--565f1";
export var businessHours = "index-module--business-hours--c6f19";
export var cHeading1 = "index-module--c-heading-1--61ad7 default-module--font-bold--e6812";
export var group2 = "index-module--group-2--d8ce6";
export var group2Annotation = "index-module--group-2-annotation--4c001";
export var group2AnnotationItem = "index-module--group-2-annotation-item--5cace";
export var group2Heading = "index-module--group-2-heading--77baf default-module--font-bold--e6812";
export var group2Heading_inner = "index-module--group-2-heading_inner--6928d";
export var group2Item = "index-module--group-2-item--7861e";
export var group2Item2 = "index-module--group-2-item-2--72f23 index-module--group-2-item--7861e";
export var group2Link = "index-module--group-2-link--09c4f default-module--font-bold--e6812";
export var group2List = "index-module--group-2-list--ee111";
export var kv = "index-module--kv--58786";
export var kvItem = "index-module--kv-item--19551";
export var kvSlider = "index-module--kv-slider--180a3";
export var lead = "index-module--lead--1741c";
export var map = "index-module--map--43acf";
export var nav = "index-module--nav--83bfc";
export var navList = "index-module--nav-list--3b671";
export var textJustify = "index-module--text-justify--9e088";